module.exports = __webpack_public_path__ + "static/img/2.7bcfa4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/2.jpg
// module id = ODs9
// module chunks = 29